import styled from 'styled-components';
import { mediaBreakpointUp } from 'styles/grid';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Item = styled.div`
  flex: 1;
  min-width: 100%;
  margin-right: 0;
  margin-left: 0;
  ${mediaBreakpointUp.md} {
    min-width: 0;
  }
`;

export const LeftItem = styled(Item)`
  margin-bottom: 8px;
  ${mediaBreakpointUp.md} {
    margin-right: 8px;
    margin-bottom: 0px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  background-color: ${({ theme }) =>
    theme.configs.trackingDetailsBox.headerAndFooter.bgColor};
  padding: 8px 12px;
  justify-content: space-between;
  align-items: center;
  height: 52px;
`;

export const Title = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
  color: ${({ theme }) => theme.configs.mainBox.fontColor};
  font-weight: bold;
`;

export const RightItem = styled(Item)`
  display: flex;
  flex: 2;
  ${mediaBreakpointUp.md} {
    margin-left: 8px;
  }
`;

export const ShipmentItems = styled(Item)`
  display: flex;
  flex: 1;
  ${mediaBreakpointUp.md} {
    margin-left: 8px;
  }
`;
